import {RouterGuard, RouterGuardOtps} from '@/libs/router';

/**
 *
 * @param guards
 */
export const can = (guards: RouterGuard[]) => (opts: RouterGuardOtps) => {
  return guards.map((guard) => guard(opts));
};
